import { theme } from '@ahmdigital/ui';
import { useFormikContext } from 'formik';
import Icon from '@ahmdigital/icons-web';
import React from 'react';

import { ButtonWrapper, Label, StyledButton, StyledP, StyledSpan, Wrapper } from './styles';

const { colors } = theme;

const MAX_ADDITIONAL_TRAVELLERS = 9;
const ZERO_ADDITIONAL_TRAVELLERS = 0;

type Props = {
  travellerCount: number;
  setTravellerCount: (value: number) => void;
};

const TravellerCounter = ({ travellerCount, setTravellerCount }: Props) => {
  const { setFieldValue } = useFormikContext();

  const incrementTraveller = () => {
    if (travellerCount < MAX_ADDITIONAL_TRAVELLERS) {
      setTravellerCount(travellerCount + 1);
    }
  };

  const decrementTraveller = () => {
    if (travellerCount > ZERO_ADDITIONAL_TRAVELLERS) {
      const travellerCountPlusPrimary = travellerCount + 1;
      setFieldValue(`travelerAge_${travellerCountPlusPrimary}`, undefined);
      setTravellerCount(travellerCount - 1);
      setFieldValue(`travelerAge_${travellerCount + 1}`, '');
    }
  };

  const disableDecrement = travellerCount === ZERO_ADDITIONAL_TRAVELLERS;
  const disableIncrement = travellerCount === MAX_ADDITIONAL_TRAVELLERS;

  return (
    <Wrapper>
      <div>
        <Label variant="bold">Add additional travellers</Label>
        <StyledP>Limited to 10 travellers, max 4 adults</StyledP>
      </div>
      <ButtonWrapper>
        <StyledButton aria-label="decrement-button" disabled={disableDecrement} onClick={decrementTraveller}>
          <Icon fill={disableDecrement && colors.grey30} name="minus-circle" size="medium" />
        </StyledButton>
        <StyledSpan>{travellerCount}</StyledSpan>
        <StyledButton aria-label="increment-button" disabled={disableIncrement} onClick={incrementTraveller}>
          <Icon fill={disableIncrement && colors.grey30} name="plus-circle" size="medium" />
        </StyledButton>
      </ButtonWrapper>
    </Wrapper>
  );
};

export default TravellerCounter;
